requirejs.config({
	baseUrl: "/js",
	paths: {
		tinymce: 'lib/tinymce/js/tinymce/classes',
		'tinymce-plugins': 'lib/tinymce/js/tinymce/plugins',
		'tinymce/tableplugin': 'lib/tinymce/js/tinymce/plugins/table/classes',
		'tinymce/pasteplugin': 'lib/tinymce/js/tinymce/plugins/paste/classes',
		'tinymce/modern': 'lib/tinymce/js/tinymce/themes/modern/src/main/js/tinymce/modern',
		'tinymce-langs': 'lib/tinymce/js/tinymce/langs',
		'moment': 'lib/moment'
	},
	urlArgs: "bust=" + (new Date()).getTime()
});

// pages
requirejs(['chat', 'post-view', 'community-threads-view', 'community-threads-add', 'community-posts-add',
		   'account-crop-avatar', 'post-form', 'user-view', 'account-settings',
		   'dashboard', 'messages', 'admin-discussions-view', 'community-blog', 'notifications',
		   'community-search', 'suggestions-view', 'reports', 'collection-forms', 'search']);

// elements
requirejs(['header', 'debug', 'forms', 'post-carousel', 'tooltips', 'dropdown-button', 'analytics',
		   'collections', 'responsive', 'switch-element', 'admin', 'extensible-option-group',
		   'css-auto-reload', 'open-dialog-links', 'prevent-doubleclick']);

// tinymce dependencies
requirejs(['lib/jquery.mathquill', 'lib/fileuploader']);

define("app", function(){});

